import type { ShippingAddressFormFragment } from './ShippingAddress.types';

type ShippingAddressSource = Readonly<{
  name?: string | null;
  phone?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  countryCode?: string | null;
  validated?: boolean | null;
}>;

export const toShippingAddressFormFragment = (address: ShippingAddressSource | null | undefined): ShippingAddressFormFragment | undefined =>
  address
    ? {
        name: address.name || '',
        phone: address.phone || '',
        address1: address.address1 || '',
        address2: address.address2 || '',
        city: address.city || '',
        state: address.state || '',
        postalCode: address.postalCode || '',
        country: address.country || '',
        countryCode: address.countryCode || '',
        validated: address.validated || false,
      }
    : undefined;
